import React, { useContext, useEffect, useState } from 'react';

import { Container, Grid, LinearProgress } from '@mui/material';
import { PageHeader } from '../../common';
import { FetchContext, NavContext, NavRoutes } from '../../contexts';
import { UfficiContext, UfficiProvider } from './UfficiContext';
import { UfficiList } from './components';

const PageContent = (props) => {

    const {
        user
    } = useContext(FetchContext);

    const {
        addBreadcrumbToken,
        setBread,
        navigateTo,
        getRouteTo,
    } = useContext(NavContext);

    const {

        state,
        setState,

        isLoadingTipiUffici,
        getTipiUfficiAsync,

        isLoadingUffici,
        getUfficiAsync,

        isDeletingUfficio,
        deleteUfficioAsync,

        isLoadingUfficiNonConvalidati,
        getUfficiNonConvalidatiAsync,
    } = useContext(UfficiContext)

    const {
        uffici,
        tipiUffici,
        deleteUfficio,
        ufficiNonConvalidati,
        tipiUfficiFilter,
    } = state;

    const loadMoreHandler = async (pageIndex, pageSize, searchText, notConvalidatedFilter, validFilter, notValidFilter, tipiUfficiFilter) => {
        await getUfficiAsync(pageIndex, pageSize, searchText, notConvalidatedFilter, validFilter, notValidFilter, tipiUfficiFilter);
    }

    const [isLoading, setIsLoading] = useState(false);
    useEffect(() => {
        setIsLoading(isLoadingUffici || isDeletingUfficio);
    }, [isLoadingUffici, isDeletingUfficio]);

    const queryParams = new URLSearchParams(window.location.search);
    const [notConvalidatedFilter, setNotConvalidatedFilter] = useState(queryParams.get('notConvalidated') ?? false);
    const [validFilter, setValidFilter] = useState(true);
    const [notValidFilter, setNotValidFilter] = useState(true);
    const [pageIndex, setPageIndex] = useState(0);
    const [pageSize, setPageSize] = useState(25);
    const [searchText, setSearchText] = useState("");
    const searchClickHandler = async (searchText) => {
        if (uffici) {
            loadMoreHandler(0, pageSize, searchText, notConvalidatedFilter, validFilter, notValidFilter, tipiUfficiFilter);
            setSearchText(searchText);
        }
    };

    const ufficiListActionClickHandler = async (action, data) => {
        switch (action) {
            case "Edit":
                window.open(getRouteTo(NavRoutes.Ufficio, [data.id]), "_blank").focus()
                break;
            case "Clone":
                let queryString = "?";
                queryString += "nome=" + data.nome;
                queryString += "&tipoUfficioId=" + data.tipoUfficioId;

                let url = NavRoutes.UfficioAdd + queryString;
                window.open(url, "_blank").focus()
                break;
            case "Add":
                window.open(NavRoutes.UfficioAdd, "_blank").focus()
                break;
            case "Delete":
                await deleteUfficioAsync(data.id);
                break;
            case "Wizard":
                getUfficiNonConvalidatiAsync();
            default:
                break;
        }
    }

    useEffect(() => {
        if (ufficiNonConvalidati?.totalCount > 0) {
            addBreadcrumbToken(ufficiNonConvalidati.result[0].nome, getRouteTo(NavRoutes.Ufficio, [ufficiNonConvalidati.result[0].id]));
            navigateTo(NavRoutes.ContattiWizard, [ufficiNonConvalidati.result[0].id]);
        }
    }, [ufficiNonConvalidati]);

    useEffect(() => {
        if (!tipiUffici) return;
        const queryParams = new URLSearchParams(window.location.search);
        const notConvalidated = queryParams.get('notConvalidated');
        getUfficiAsync(0, 25, searchText, notConvalidated, true, true, tipiUffici.result.map(x => x.id));
    }, [tipiUffici]);

    useEffect(() => {
        if (user) {
            addBreadcrumbToken("Uffici");
            getTipiUfficiAsync();
        }
    }, [user]);

    return (
        <>
            <Container>
                {isLoading && <LinearProgress />}
                <Grid container>
                    <Grid item xs={12}>
                        <PageHeader
                            disabled={isLoading}
                            onSearchClick={searchClickHandler}
                            search
                            title="Uffici"
                            subtitle="Gestisci gli uffici" />
                    </Grid>
                    <Grid item xs={12}>
                        <UfficiList
                            notConvalidatedFilter={notConvalidatedFilter}
                            setNotConvalidatedFilter={setNotConvalidatedFilter}
                            validFilter={validFilter}
                            setValidFilter={setValidFilter}
                            notValidFilter={notValidFilter}
                            setNotValidFilter={setNotValidFilter}
                            pageIndex={pageIndex}
                            setPageIndex={setPageIndex}
                            pageSize={pageSize}
                            setPageSize={setPageSize}
                            searchText={searchText}
                            itemsPerPage={25}
                            onLoadMore={loadMoreHandler}
                            disabled={isLoading}
                            onActionClick={ufficiListActionClickHandler} />
                    </Grid>
                </Grid>

            </Container>

        </>
    );
}

export const UfficiPage = () => {

    return (
        <UfficiProvider>
            <PageContent />
        </UfficiProvider>
    );
}